import {BookPayload, GeneralAction} from '../../../@types/actions';
import {BOOK_EVENT} from '../../../constants/LiveConstants';

export const BookEventAction = (data: BookPayload): GeneralAction<BookPayload> => ({
    type: BOOK_EVENT,
    payload: data
});
